import { ERROR_OK } from "~/constants/const-http";
import { useAsyncState } from "@vueuse/core";
import { getProductVacationDates } from "~/services/vacation";

export function useProductCruiseDate() {
  const {state, execute} = useAsyncState(
    async () => {
      const { code, data, msg } = await getProductVacationDates();
      if (code !== ERROR_OK) {
        throw new Error(msg);
      }
      return data;
    },
    [],
    {
      immediate: false,
    }
  );
  return {
    state,
    execute
  };
}
